import { useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { LangContext } from 'store/lang/LangProvider';

function TestimonialCard({ testimonial }) {
  const theme = useTheme();
  const lang = useContext(LangContext);
  const S3_URL = process.env.REACT_APP_S3_URL;
  return (
    <Box
      boxShadow={`0px 0px 10px 0px ${theme.palette.cardShadow2}`}
      gap={2}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      lineHeight={1.2}
      backgroundColor={theme.palette.background.level1}
      overflow={'hidden'}
      sx={{
        width: '100%',
        height: '400px',
        padding: {
          xs: 4,
          md: 6,
          lg: 6,
        },
        borderRadius: {
          xs: 5,
        },
      }}
    >
      <img
        loading="lazy"
        src={S3_URL+'/'+testimonial.img}
        alt={testimonial.alt}
        width={testimonial.width}
        height={testimonial.height}
        style={{mixBlendMode: 'multiply'}}
      />
      <Box
        component="hr"
        backgroundColor={theme.palette.common.black}
        width={75}
      />
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}
      >
        <Typography
          component="h2"
          variant="h6"
          align={'center'}
          sx={{
            fontWeight: 700,
            color: '#131250',
          }}
        >
          <FormattedMessage id={testimonial.author} defaultMessage={''} />{' '}
        </Typography>
        {testimonial.subtitle && (
          <Typography
            component="p"
            variant="h7"
            align={'center'}
            sx={{
              fontWeight: 400,
              color: '#131250',
              textWrap: 'pretty',
              width: '70%',
            }}
          >
            <FormattedMessage id={testimonial.subtitle} defaultMessage={' '} />{' '}
          </Typography>
        )}
      </Box>
      <Box display={'flex'} flexDirection={'column'} gap={2}>
        <Typography
          key={crypto.randomUUID()}
          component="p"
          variant="p"
          align={'center'}
          sx={{
            fontWeight: 400,
            color: theme.palette.text.secondary,
            textWrap: 'balance',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            lineHeight: 1.4,
            maxHeight: '5.6em', // 3 lines * 1.4 line-height
          }}
        >
          <FormattedMessage id={testimonial.p[0]} />{' '}
        </Typography>
        <Typography 
          component={Link}
          to='/testimonials'
          align={'center'}
          sx={{
            fontWeight: 700,
            color: theme.palette.primary.main,
            textWrap: 'balance',
          }}
        >
          {lang.value == 'es' ? 'Ver mas' : 'See more'}
        </Typography>
      </Box>
    </Box>
  );
}

TestimonialCard.propTypes = {
  testimonial: PropTypes.shape({
    img: PropTypes.string,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    author: PropTypes.string,
    subtitle: PropTypes.string,
    p: PropTypes.arrayOf([PropTypes.string]),
    seeMore: PropTypes.string
  }),
};
export default TestimonialCard;
